import { createClient } from "@supabase/supabase-js";

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!supabaseUrl) {
  throw new Error(
    "Hiányzik a REACT_APP_SUPABASE_URL környezeti változó."
  );
}

if (!supabaseAnonKey) {
  throw new Error(
    "Hiányzik a REACT_APP_SUPABASE_ANON_KEY környezeti változó."
  );
}

export const supabase = createClient(
  supabaseUrl,
  supabaseAnonKey
);